import React, { useState, useEffect } from "react";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import DexterCall from "../../Images/UpdatedDexter-call.svg";
import { useNavigate } from "react-router-dom";
import {
  Pincode_Verification,
  ROUTE_MOBILE_VERIFICATION,
} from "../../Routes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../libs/axiosConfig";
import { useSelector } from "react-redux";
import Toast from "../../Components/ToastMsg/Toast";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { useDispatch } from "react-redux";
import { updateAddressLine } from "../../Store/dexterrPortfolio/actions";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import LogoutModal from "../../Components/LogoutModal";

const AddressLine = () => {
  const dispatch = useDispatch();
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const [isLoading, setIsLoading] = useState(false);
  // const refreshToken = useSelector(selectRefreshToken);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const handleClearButtonClick = (field) => {
    if (field === "addressLine1") {
      setAddressLine1("");
    } else if (field === "addressLine2") {
      setAddressLine2("");
    } else if (field === "city") {
      setCity("");
    }
    setFormErrors({});
  };

  const handleSubmit = async () => {
    if (addressLine1 && city) {
      // toast.success("Form submitted successfully");
    } else {
      toast.error("Please fill all the required details");
    }
    try {
      
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      setApiCallsInProgress(apiCallsInProgress + 1);
      const formattedAddress1 = addressLine1.replace(/[,\.]/g, " ");
      const formattedAddress2 = addressLine2.replace(/[,\.]/g, " ");
      const formattedCity = city.replace(/[,\.]/g, " ");

      // Make a POST request to the first API endpoint
      const firstapi =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
      const requestBody = {
        CustomerKycDetails: {
          request_type: "post",
          mobileNumber: phoneNumber,
          pan: panNumber,
          addr1: formattedAddress1,
          addr2: formattedAddress2,
          city: city,
          // fullAddress: `${formattedAddress1} ${formattedAddress2} ${formattedCity}`,
        },
      };
      // Dispatch action to update fullAddress
      const fullAddressValue = `${addressLine1} ${addressLine2} ${city}`;
      dispatch(updateAddressLine(fullAddressValue));
      console.log("dispatch:", fullAddressValue);
      const response = await axios.post(firstapi, requestBody, { headers });
      // console.log("First API Response:", response.data);

      // If the first API call is successful, make a second POST request to the second API endpoint
      // const secondapi =
      //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails";
      // const secondRequestBody = {
      //   addressLine1: formattedAddress1,
      //   addressLine2: formattedAddress2,
      //   city: city,
      //   // fullAddress: `${formattedAddress1} ${formattedAddress2} ${formattedCity}`,
      // };

      // const secondResponse = await axios.post(secondapi, secondRequestBody, {
      //   headers,
      // });
      // console.log("Second API Response:", secondResponse.data);

      // If the second API call is successful, make a third POST request to the third API endpoint
      if (response.status === 200) {
        Navigate(Pincode_Verification);
      } else {
        Toast.error(
          response.data.errorMessage || response.data.message
        );
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const validateInput = (input) => {
    const regex = /^[a-zA-Z0-9\s,.]+$/;
    return regex.test(input);
  };

  const handleInputChange = (e, setState) => {
    const inputValue = e.target.value;
    if (inputValue === "" || validateInput(inputValue)) {
      setState(inputValue);
    } else if (inputValue.slice(0, -1) === "") {
      setState("");
    } else {
      setFormErrors({
        // [e.target.name]: "Only alphabets, numbers, commas, and full stops are allowed",
      });
    }
  };

  return (
    <div className="Addressline_Main_Container">
      <div className="Addressline_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className={classes.DexterLogo} />
        </div>
      </div>
      <div className="AddressLine_Container">
        <p className="Input_Heading_text"> Address Details </p>
        <span className="Input_Sub_heading">
          Dexterr will not be sending any physical mail to this address.
        </span>
        <div className="Addressline_Filed_Box">
          <span className="Enter_address_text">Address Line 1 </span>
          <div className="address_input_container">
            <input
              className={`${classes.Input_Filed} ${
                formErrors.addressLine1 ? classes.Error : ""
              }`}
              name="addressLine1"
              value={addressLine1}
              onChange={(e) => handleInputChange(e, setAddressLine1)}
            />
            <button
              className="Cross_button"
              onClick={() => handleClearButtonClick("addressLine1")}
            />
          </div>
        </div>
        {formErrors.addressLine1 && (
          <span className={classes.Error_Message}>
            {formErrors.addressLine1}
          </span>
        )}

        <div className="Addressline2_Filed_Box">
          <span className={classes.Enter_mobile_text}>Address Line 2 </span>
          <div className={classes.Input_Inner_Container}>
            <input
              className={`${classes.Input_Filed} ${
                formErrors.addressLine2 ? classes.Error : ""
              }`}
              name="addressLine2"
              value={addressLine2}
              onChange={(e) => handleInputChange(e, setAddressLine2)}
            />
            <button
              className={classes.Cross_button}
              onClick={() => handleClearButtonClick("addressLine2")}
            />
          </div>
        </div>
        {formErrors.addressLine2 && (
          <span className={classes.Error_Message}>
            {formErrors.addressLine2}
          </span>
        )}

        {/* <p className={classes.Input_Heading_text}>What's your City? </p> */}
        <div className="City_Filed_Box">
          <span className={classes.Enter_mobile_text}>Enter Your City </span>
          <div className={classes.Input_Inner_Container}>
            <input
              className={`${classes.Input_Filed} ${
                formErrors.city ? classes.Error : ""
              }`}
              name="city"
              value={city}
              onChange={(e) => handleInputChange(e, setCity)}
            />
            <button
              className={classes.Cross_button}
              onClick={() => handleClearButtonClick("city")}
            />
          </div>
        </div>
        {formErrors.city && (
          <span className={classes.Error_Message}>{formErrors.city}</span>
        )}

        <button className="Submit_button" onClick={handleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      ;
    </div>
  );
};

export default AddressLine;
